/* global React, t */
// ============================================================
// MERKET LASTESKJERM
// ============================================================
// Maskoten og logoen sto til nå bare på oppstartsskjermen (`__boot` i
// index.html og `BackendLoading` i app.jsx). Begge eier hele viewporten og
// kjører før appen har malt noe som helst, så ingen av dem kunne brukes inne i
// en side som allerede står der. Flatene som venter på data fikk derfor en naken
// «Laster …» i et kort — mest synlig i byråflaten, som ikke har noen annen
// oppstartsskjerm å arve stemningen fra.
//
// Denne er den samme skjermen, men inne i det området som venter: den fyller
// beholderen sin i stedet for skjermen, og henter fargene fra temaet i stedet
// for å hardkode dem (oppstartsskjermen må hardkode, den maler før CSS-en er
// lest — her er den lest for lengst).

const brandLoadingAssets = () => ({
  mascot: window.__resources?.superPlummaLoadingBoot || 'src/img/superPlummaLoading-360.webp',
  logo: window.__resources?.plummeLogoNew || 'src/img/plummeLogoNew-480.webp',
});

function BrandLoading({ text, compact = false, className = '' }) {
  const { mascot, logo } = brandLoadingAssets();
  return <div
    className={'brand-loading' + (compact ? ' compact' : '') + (className ? ' ' + className : '')}
    role="status"
    aria-live="polite"
  >
    {/* Maskoten er dekor. Teksten under bærer beskjeden, og den leses opp. */}
    <img className="brand-loading-mascot" src={mascot} alt="" />
    <img className="brand-loading-logo" src={logo} alt="Plumme" />
    <div className="brand-loading-text">{text || t('app.loading', 'Laster …')}</div>
  </div>;
}

Object.assign(window, { BrandLoading });
